import CampaignReport from "./pages/CampaignReport";
import PhishingManager from "PhishingManager";
import { useStores } from "Hooks/useStore";
import { CAMPAIGN_DATA } from "./pages/CampaignReport/CampaignReport.type";
import { APP_ROUTES } from "Pages/App/App.constants";
import './styles/PhishingManager.module.scss';


const Phishing = () => {
    const { reportStore } = useStores();
    const { campaignData } = reportStore;
    const showPhishingReport = window.location.pathname.includes(APP_ROUTES.PHISHING);

    const updateCampaignData = (data: CAMPAIGN_DATA | null) => {
        reportStore.setCampaignData(data);
    }

    const resetCampaginData = () => {
        if(campaignData?.id) updateCampaignData(null);
    }

    return <div className="phishingManager">
        {showPhishingReport ? <CampaignReport showOverallReport={campaignData == null} campaignId={campaignData?.id || null} tenentId={campaignData?.tenentId || null} resetCampaginData={resetCampaginData} /> : <PhishingManager updateCampaignData={updateCampaignData} />}
    </div>
}

export default Phishing;